<script setup lang="ts">
import { LanguagesIcon } from 'lucide-vue-next'

const { t } = useI18n()
const account = useAccountStore()
const router = useRouter()
const localePath = useLocalePath()
const { localeMenu } = storeToRefs(useLocaleMenuStore())
const runtimeConfig = useRuntimeConfig()

const onLogout = async () => {
  await account.logout()
  let loginUrl = '/login'
  if (!runtimeConfig.public.auth0ClientId) {
    loginUrl = '/admin/login'
  }
  router.replace(localePath(loginUrl))
}

const props = defineProps<{
  label: string
}>()

const items = computed(() => {
  return [
    {
      label: props.label,
      disabled: false,
    },
    {
      separator: true,
      disabled: false,
    },
    {
      label: t('ユーザー設定'),
      disabled: true,
      pIconClass: 'pi pi-user',
    },
    {
      label: t('言語設定'),
      iconComponent: LanguagesIcon,
      items: localeMenu.value as DMenuItem[],
      disabled: false,
    },
    {
      label: t('ログアウト'),
      pIconClass: 'pi pi-sign-out',
      disabled: false,
      command: () => {
        onLogout()
      },
    },
  ]
})
</script>

<template>
  <DTieredMenu :items="items" popup>
    <template #trigger="{ on }">
      <slot name="trigger" :on="on"></slot>
    </template>
  </DTieredMenu>
</template>
